const faqs = [
  {
    q: '6080影院需要付费吗？',
    a: '完全不需要！6080影院是一个免费影视大全平台，所有高清电影免费看和免费电视剧全集均可在线观看，无需任何付费或订阅。',
  },
  {
    q: '视频播放会卡顿吗？',
    a: '不会。我们采用多线路智能切换技术，自动选择最优播放线路，确保高清视频播放流畅不卡。同时支持1080P蓝光画质，观影体验媲美付费平台。',
  },
  {
    q: '影片资源多久更新一次？',
    a: '我们每天更新50部以上的高清影视内容，新片上映后第一时间上线。热播剧集同步跟播，确保您不错过任何精彩内容。',
  },
  {
    q: '可以用手机观看吗？',
    a: '当然！6080影院完美适配手机、平板和电脑，高清在线影院级画质在所有设备上都能流畅呈现，随时随地想看就看。',
  },
  {
    q: '需要安装播放器或插件吗？',
    a: '不需要。直接在浏览器中打开即可观看，无需下载任何播放器或安装插件，简单方便又安全。',
  },
  {
    q: '影片画质能达到什么标准？',
    a: '我们提供最高1080P蓝光级画质，部分热门影片支持4K超清。可根据您的网络状况自由切换清晰度，确保最佳观看体验。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于6080影院，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <div className="p-4 md:p-5">
                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded bg-primary-100 mt-0.5">
                    <i className="ri-question-line text-primary-500 text-xs"></i>
                  </span>
                  <div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-100 mb-2">
                      {faq.q}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}